module.exports = __webpack_public_path__ + "img/template1.55a3eb7c.jpg";